import React, { lazy } from 'react';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import envService from '../services/envService';
import UseData from '../pages/UseData';

const Login = lazy(() => import('../pages/Login'));
const Register = lazy(() => import('../pages/Register'));
const Home = lazy(() => import('../pages/Home'));
const Request = lazy(() => import('../pages/Request'));
const RequestData = lazy(() => import('../pages/RequestData'));
const Data = lazy(() => import('../pages/Data'));
const Test = lazy(() => import('../pages/Test'));

// Import lazy components

const AppRoutes: React.FC = () => {
  return (

    <BrowserRouter basename={envService.getPublicUrl()}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/edit" element={<Register />} />
        <Route path="/home" element={<Home />} />
        {/* <Route path="/request_" element={<Request />} /> */}
        <Route path="/request" element={<RequestData />} />
        <Route path="/data" element={<UseData />} />
        <Route path="/test" element={<Test />} />
        {/* <Route path="/data/details" element={<UseDataDetails />} /> */}
      </Routes>
    </BrowserRouter>

  );
};

export default AppRoutes;
